export const calculatePerformanceIncrease = (barchartdata, period = 'month') => {
    if (!barchartdata || Object.keys(barchartdata).length === 0) {
        return {
            songs_increase: 0,
            views_increase: 0,
            royalty_increase: 0,
        };
    }

    const allMonthsData = {};

    // Aggregate data from all platforms by month
    for (const platform in barchartdata) {
        for (const month in barchartdata[platform]) {
            if (!allMonthsData[month]) {
                allMonthsData[month] = {
                    total_songs: 0,
                    total_views: 0,
                    total_royalty: 0,
                };
            }
            allMonthsData[month].total_songs += barchartdata[platform][month].total_songs;
            allMonthsData[month].total_views += barchartdata[platform][month].total_views;
            allMonthsData[month].total_royalty += barchartdata[platform][month].total_royalty;
        }
    }

    const sortedMonths = Object.keys(allMonthsData).sort((a, b) => new Date(b) - new Date(a));

    const calculateIncrease = (current, previous) => {
        if (previous === 0) {
            return current > 0 ? 100 : 0;
        }
        return ((current - previous) / previous) * 100;
    };

    if (period === 'year') {
        if (sortedMonths.length < 24) {
            return { songs_increase: 0, views_increase: 0, royalty_increase: 0 };
        }

        const currentYearMonths = sortedMonths.slice(0, 12);
        const previousYearMonths = sortedMonths.slice(12, 24);

        const sumMetrics = (months) => months.reduce((acc, month) => {
            acc.total_songs += allMonthsData[month].total_songs;
            acc.total_views += allMonthsData[month].total_views;
            acc.total_royalty += allMonthsData[month].total_royalty;
            return acc;
        }, { total_songs: 0, total_views: 0, total_royalty: 0 });

        const currentYearData = sumMetrics(currentYearMonths);
        const previousYearData = sumMetrics(previousYearMonths);

        return {
            songs_increase: calculateIncrease(currentYearData.total_songs, previousYearData.total_songs),
            views_increase: calculateIncrease(currentYearData.total_views, previousYearData.total_views),
            royalty_increase: calculateIncrease(currentYearData.total_royalty, previousYearData.total_royalty),
        };
    }

    // Default to 'month'
    if (sortedMonths.length < 2) {
        return { songs_increase: 0, views_increase: 0, royalty_increase: 0 };
    }

    const currentMonthData = allMonthsData[sortedMonths[0]];
    const previousMonthData = allMonthsData[sortedMonths[1]];

    return {
        songs_increase: calculateIncrease(currentMonthData.total_songs, previousMonthData.total_songs),
        views_increase: calculateIncrease(currentMonthData.total_views, previousMonthData.total_views),
        royalty_increase: calculateIncrease(currentMonthData.total_royalty, previousMonthData.total_royalty),
    };
};
